// Códigos de clase (8 caracteres) — distintos de tareas (6) para evitar confusión.

const CLASSROOM_CODE_CHARS = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
export const CLASSROOM_CODE_LENGTH = 8;

export interface Classroom {
  id: string;
  teacherId: string;
  teacherName?: string;
  title: string;
  createdAt: number;
}

export interface ClassroomMember {
  id: string;
  classroomCode: string;
  classroomTitle: string;
  teacherId: string;
  teacherName?: string;
  studentId: string;
  studentName: string;
  joinedAt: number;
}

export function generateClassroomCode(): string {
  let code = "";
  for (let i = 0; i < CLASSROOM_CODE_LENGTH; i++) {
    code += CLASSROOM_CODE_CHARS[Math.floor(Math.random() * CLASSROOM_CODE_CHARS.length)];
  }
  return code;
}

export function normalizeClassroomCode(raw: string): string {
  return raw.trim().toUpperCase().replace(/\s/g, "");
}

export function classroomMemberId(classroomCode: string, studentId: string): string {
  return `${normalizeClassroomCode(classroomCode)}_${studentId}`;
}

export function isValidClassroomCode(code: string): boolean {
  const n = normalizeClassroomCode(code);
  return n.length === CLASSROOM_CODE_LENGTH && /^[A-Z2-9]+$/.test(n);
}
